module.exports = __webpack_public_path__ + "media/images/icon__unlocked@2x-d02b331e70c11dc1de643e905cb9243e.png";